export default {
  user: {},
  token: '',
  isMember: true
}